import { Storage } from '@ionic/storage-angular';
import { ApiService } from '../services/api/api.service';
import { ROUTES } from '../services/api/api.constants';
import { Injectable } from '@angular/core';
import {Exercise} from '../models/Exercise';
import { S3Provider } from './S3Provider';

@Injectable({
  providedIn: 'root'
})

export class ExerciseProvider {
  constructor(
    private storage: Storage,
    private api: ApiService,
    private s3Provider: S3Provider,
  ) { }

  async getExerciseType(): Promise<any> {
    const base = ROUTES.exercises.exerciseType;
    const result = (await this.api.get(base));
    return result.data;
  }

  async getExercises(data): Promise<any> {
    let base = ROUTES.exercises.getExercises(data.gymId);
    base += `?page=${data.page}`;
    if (data.search !== '') {
      base += `&q=${data.search}`;
    }
    if (data.exerciseType !== '') {
      base += `&id_tipo_ejercicio=${data.exerciseType}`;
    }
    const result = (await this.api.get(base));
    const exercises = result.data.map( exercise => {
      return new Exercise(exercise);
    });
    const meta = result.meta;
    const links = result.links;
    return {
      exercises,
      meta,
      links
    };
  }

  async saveExercise(data: FormData, gymId: number): Promise<any> {
    let uploadedUrl: string;
    try {
      const banner = data.get('banner');
      if (banner instanceof File) {
        const cleanName = banner.name.replace(/\s+/g, '');
        const newFile = new File([banner], cleanName, { type: banner.type });

        uploadedUrl = await this.s3Provider.upload(newFile) as string;
        data.set('banner', uploadedUrl);
      }

      const base = ROUTES.exercises.saveExercise(gymId);
      const response = await this.api.postFile(base, data);
      return response;
    } catch (err) {
      if (uploadedUrl) {//Eliminamos en s3
        const delUrl = ROUTES.s3.deleteFile(uploadedUrl.split('https://oden-app.s3.us-west-1.amazonaws.com/')[1]);
        await this.api.delete(delUrl);
      }
      throw err;
    }
  }

  async addExerciseType(name): Promise<any> {
    const base = ROUTES.exercises.addExerciseType;
    const result = await this.api.post(base, {nombre: name});
    return result;
  }

  async updateExercise(data, gymId, updateImage, fotoOld): Promise<any> {
    if (updateImage) {
      if(fotoOld && fotoOld.includes('https://storage.googleapis.com') && fotoOld!='https://storage.googleapis.com/oden-storage/imgs/photo_2019-02-20_16-24-06.jpg'){        
        //eliminar foto antigua del gcloud storage     
        data.append('foto_delete', fotoOld);
      }else if(fotoOld && fotoOld.includes('oden-app.s3.us-west-1.amazonaws.com') && fotoOld!='https://storage.googleapis.com/oden-storage/imgs/photo_2019-02-20_16-24-06.jpg'){       
        const url= ROUTES.s3.deleteFile(fotoOld.split('https://oden-app.s3.us-west-1.amazonaws.com/')[1]);       
        this.api.delete(url);
      }
      const banner = data.get('banner');
      let newFile = new File([banner], banner.name.replace(/ /g, ""), {type:  banner.type});     
      let url:any = await this.s3Provider.upload(newFile)     
      data.set('banner', url);
    }

    const base = ROUTES.exercises.updateExercise(gymId);
    const response = await this.api.postFile(base, data);    
    return response;
  }

  async addExcerciseImage(data, gymId): Promise<any> {
    const base = ROUTES.exercises.addExcerciseImage(gymId);
    const response = await this.api.postFile(base, data);    
    return response;
  }

  async deleteExcerciseImage(data, gymId): Promise<any> {
    const base = ROUTES.exercises.deleteExcerciseImage(gymId);
    const response = await this.api.postFile(base, data);    
    return response;
  }

  async deleteExcercise(gymId, exerciseId): Promise<any> {
    const base = ROUTES.exercises.deleteExcercise(gymId, exerciseId);
    const response = await this.api.delete(base);    
    return response;
  }
}
